import React, {useState, useMemo} from 'react';
import { Redirect } from 'react-router-dom';
import { Form, Input, Button, notification } from 'antd';

import AuthService from './../../services/AuthService';
import { setToken } from '../../helpers/token';
import AuthPageWrapper from './AuthPageWrapper';
import logo from './../../logo.svg';

import './auth.scss';

const { Item: FormItem } = Form;

const Login = () => {
    const [state, setState] = useState('initial');
    const validateStatus = useMemo(() => (state === 'unAuth' ? 'error' : ''), [state]);

    const handleSubmit = ({username, password}) => {
        AuthService.login({username, password}).then(({status, jwtToken}) => {
            if (status === 200) {
                setToken(jwtToken);
                setState('success');
            } else {
                notification.error({
                    message: 'Սխալ մուտքային տվյալներ',
                    className: 'ant-notification',
                });
                setState('unAuth');
            }
        })
    };

    if (state === 'success') return <Redirect to={'/'}/>;

    return (
        <AuthPageWrapper hasNavigation={false}>
            <div className='logo'>
                <img src={logo} alt='logo'/>
            </div>
            <div className='welcome-text'>ԲԱՐԻ ԳԱԼՈՒՍՏ VELOX</div>
            <Form className="login-form" onFinish={handleSubmit}>
                <FormItem
                    {...(state === 'unAuth' && { validateStatus: validateStatus })}
                    name='username'
                    rules={[
                        { required: true, message: 'Պարտադիր դաշտ' },
                        { type: 'email', message: 'Սխալ Էլ. հասցե'},
                      ]}
                    style={{ width: 400, marginBottom: '24px' }}
                >
                    <Input
                        size={"large"}
                        placeholder="Էլ. հասցե"
                    />
                </FormItem>

                <FormItem
                  {...(state === 'unAuth' && { validateStatus: validateStatus })}
                    name='password'
                    style={{ width: 400, height: 48, marginBottom: '24px' }}
                    rules={[{ required: true, message: 'Պարտադիր դաշտ' }]}
                >
                    <Input.Password
                        size={"large"}
                        placeholder="Գաղտնաբառ"
                    />
                </FormItem>
                <FormItem style={{width: 400}} wrapperCol={{offset: 6}}>
                    <Button type="primary" htmlType="submit" className="login-form-button">
                        Մուտք
                    </Button>
                </FormItem>
            </Form>
        </AuthPageWrapper>
    )
};

export default Login;
